(function () {
  function init() {
    var header = document.querySelector('.pb-header');
    if (!header) return;

    var btn = header.querySelector('[data-pb-toggle]');
    var panel = header.querySelector('[data-pb-panel]');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (header.contains(e.target)) return;
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
